import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { BackgroundMaskCover } from "./BackgroundMaskCover";
import { isString } from "../../../Utils/Utils";
export var BackgroundMask = /*#__PURE__*/function () {
  function BackgroundMask() {
    _classCallCheck(this, BackgroundMask);

    this.composite = "destination-out";
    this.cover = new BackgroundMaskCover();
    this.enable = false;
  }

  _createClass(BackgroundMask, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.composite !== undefined) {
        this.composite = data.composite;
      }

      if (data.cover !== undefined) {
        var cover = data.cover;
        var color = isString(data.cover) ? {
          color: data.cover
        } : data.cover;
        this.cover.load(cover.color !== undefined ? cover : {
          color: color
        });
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);

  return BackgroundMask;
}();